import { useRef, useEffect } from "react";
import { microTask as t } from "../utils/micro-task.js";
import { useEvent as o } from "./use-event.js";
function c(t$1) {
  let r = o(t$1), e = useRef(false);
  useEffect(() => (e.current = false, () => {
    e.current = true, t(() => {
      e.current && r();
    });
  }), [r]);
}
export {
  c as useOnUnmount
};
